import { render, staticRenderFns } from "./createpressure.vue?vue&type=template&id=9ca1be88&"
import script from "./createpressure.vue?vue&type=script&lang=ts&"
export * from "./createpressure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createpressure.vue"
export default component.exports